<template>
    <div>
        <v-card class="mt-2 mb-2 rounded-lg">
            <v-container fluid>
                <v-row no-gutters>
                    <v-col cols="auto">
                        <v-auto-img v-if="image" :src="image" alt="Header Image" class="rounded-lg" style="width: 6.25rem; height: 6.25rem;"></v-auto-img>
                        <div v-else class="placeholder rounded-lg">
                            <v-icon color="grey lighten-1" large>mdi-image-off</v-icon>
                        </div>
                    </v-col>
                    <v-col>
                        <div class="d-flex flex-column justify-space-between pl-2 text-body-2" style="height: 6.25rem;">
                            <div>
                                <div class="d-flex justify-space-between align-items-center">
                                    <div class="course-title-block">
                                        <strong class="course-name">{{ booking.course_name }}</strong>
                                        <div v-if="booking.subtitle" class="course-subtitle text--secondary">{{ booking.subtitle }}</div>
                                    </div>
                                    <v-btn icon small>
                                        <v-icon color="info">mdi-information-outline</v-icon>
                                    </v-btn>
                                </div>
                            </div>
                            <div class="mt-auto text-caption">
                                <div class="info--text" v-if="getChildName(booking.user_id)">
                                    <span class="child-name">{{ $translate('Booked for')}} {{ getChildName(booking.user_id) }}</span>
                                </div>
                                <div v-if="booking.occasions">
                                    <v-icon small color="primary" class="mr-1">mdi-calendar-sync</v-icon>
                                    <span>{{ occasionsString }}</span>
                                </div>
                                <div class="d-flex justify-space-between align-items-center">
                                    <div>
                                        <v-icon small color="primary" class="mr-1">mdi-clock-outline</v-icon>
                                        <span>{{ Date.formatFullShort(booking.startTime).capitalize() }} - {{ Date.formatFullShort(booking.endTime) }}</span>
                                    </div>
                                    <div v-if="canCancel" class="ml-auto">
                                        <a href="#" @click.stop="cancelBooking()" class="error--text text-decoration-none">{{ $translate('CANCEL_BOOKING') }}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </div>
</template>

<script>
import { RelativeTime } from '../util.js'

export default {
    name: 'zoezi-course-booking-card',
    props: ['booking'],

    methods: {
        getChildName(user_id) {
            let canBookFor = this.$store.state?.user?.canBookFor;
            let currentUserId = this.$store.state?.user?.id;
            if (!canBookFor || canBookFor.length <= 1 || user_id == null || currentUserId == user_id) return null;
            let user = canBookFor.find(u => u.id == user_id);
            return user ? user.name : null;
        },
        cancelBooking() {
            this.$emit('cancel', this.booking);
        }
    },

    computed: {
        occasionsString() {
            return this.booking.occasions == 1 ? this.$translate('1 occasion') : this.$translate('{0} occasions').format(this.booking.occasions);
        },
        canCancel() {
            if (!this.booking.cancelRules || !this.booking.cancelRules.canCancel || !this.booking.cancelRules.lastCancelTime) {
                return false;
            }

            let lastCancelTime = new RelativeTime(this.booking.cancelRules.lastCancelTime).getDate(this.booking.startTime);
            return this.$store.state.now30s < lastCancelTime;
        },
        image() {
            return this.booking.imagekey || this.booking.course_category_imagekey;
        }
    }
}
</script>

<style scoped>
.placeholder {
    width: 6.25rem;
    height: 6.25rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #e0e0e0;
}

.course-title-block {
    flex: 1;
    min-width: 0;
}

.course-subtitle {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 0.85rem;
    line-height: 1.2;
}

.course-name, .child-name {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.child-name {
    -webkit-line-clamp: 1;
    max-width: 100%;
}
</style>
